import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { FaRegUser } from "react-icons/fa";
import { MdAddBox } from "react-icons/md";
import { useSelector } from "react-redux";
import CustomerProfileList from "./CustomerProfileList";
import "utils/protos";
import CreateCustomer from "./CreateCustomer";

const CustomerManagement = () => {
  const roles = useSelector((state) => state.auth.user.roles);
  return (
    <>
      {roles.any(["admin","vending_machine"]) ? (
        <Box sx={{ display: "flex", flex: 1 }}>
          <ListCreateTab
            mod="Customers"
            viewIcon={<FaRegUser />}
            createIcon={<MdAddBox />}
            createChildren={<CreateCustomer />}
            listChildren={<CustomerProfileList />}
          />
        </Box>
      ) : (
        <CustomerProfileList />
      )}
    </>
  );
};

export default CustomerManagement;
